module.exports = __webpack_public_path__ + "static/media/calendar-day.9c46599b.svg";